module.exports = __webpack_public_path__ + "img/image_3.2eeb4c9e.jpg";